import { dataEntryService } from "../services/data-entry.services";
import { showToast } from "@/lib/utils/toast";
import { loadDataEntries } from "./load.ops";
import { disclosureStore } from "../stores/disclosure.store";

export const fetchBulkSyncPreview = async (
  orgId,
  year,
  includeSubOrgs = false,
) => {
  return dataEntryService.syncNxmapBulk({
    orgId,
    year: Number(year),
    includeSubOrgs,
  });
};

export const confirmBulkSync = async (preview) => {
  const result = await dataEntryService.confirmNxmapBulkSync({
    toCreate: preview._toCreate || [],
    toUpdate: preview._toUpdate || [],
    toDelete: preview._toDelete || [],
  });
  const parts = [];
  if (result.created) parts.push(`${result.created} created`);
  if (result.updated) parts.push(`${result.updated} updated`);
  if (result.deleted) parts.push(`${result.deleted} deleted`);
  showToast.success(`NXMap sync: ${parts.join(", ") || "no changes"}`);
  if (disclosureStore.activeDisclosure) loadDataEntries();
  return result;
};
